module.exports = __webpack_public_path__ + "283e8a6fb71e77effaacd0c55534925f.svg";